// extracted by mini-css-extract-plugin
module.exports = {"GriftCardLayout":"GriftCardLayout___7vz7i","title":"title___1ERyM"};